export default __webpack_public_path__ + "resources/icons/d221-a717.png";